import { countBetween } from "./countBetween.js";
export function countData(data, amount, min, max) {
  const sectionSize = (max - min) / amount;
  const normalizedData = [];
  for (let i = 0; i < amount; i++) {
    const from = min + i * sectionSize;
    const to = from + sectionSize;
    normalizedData.push({
      from,
      to,
      amount: countBetween(data, from, to)
    });
  }
  return normalizedData;
}